import './ProfileFooter.scss';

import { useAuthForm } from "../../../hooks/useAuthForm";

import { Button } from "../../../common-components/Buttons/Buttons";

const ProfileFooter = () => {
    const { handleLogout } = useAuthForm();

    return (
        <div className={"profile-footer"}>
            <div className={"profile-footer_container"}>
                <div className={"profile-footer_logout"}>
                    <Button title={"Выйти"} color={"#f44336"} onClick={handleLogout}/>
                </div>
            </div>
        </div>
    )
}

export default ProfileFooter;